<template>
    <div>
        <div class="top">
            <span>{{ houseName }}</span>
            <span class="inlineblock">{{ cusName }} {{ cusMobile }}</span>
        </div>
        <div :class="preCls + 'filter'" style="margin-top: 10px">
            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            >
            </filter-date-range>
        </div>
        <div style="margin-top: 10px">
            <Table
                ref="mt"
                :columns="columns"
                :data="page.list"
                :loading="loading"
                :height="mtHeight"
            >
            </Table>
            <!-- 底部分页 -->
            <table-pager
                :total.sync="page.total"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.pageNo"
                @change="fetch"
            >
            </table-pager>
        </div>
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { currency, ymdL } from '_u/helper'
import { mapCell, pipeCell } from '_c/grid/renderCell'

import FilterDateRange from '_v/components/filter/filter-date-range'

import { orderRechargeHistory } from '@/api/order'

export default {
    name: 'order-recharge-history',

    inject: {
        $modal: {
            default: null,
        },
    },

    props: {
        houseId: {
            type: [String, Number],
            default: '',
        },
        houseName: {
            type: String,
            default: '',
        },
        cusId: {
            type: [String, Number],
            default: '',
        },
        cusName: {
            type: String,
            default: '',
        },
        cusMobile: {
            type: String,
            default: '',
        },
    },

    components: {
        FilterDateRange,
    },

    data() {
        return {
            mtHeight: 350,
            loading: false,
            page: {
                total: 0,
                list: [],
            },
            filter: {
                pageNo: 1,
                pageSize: 20,
                houseId: this.houseId,
                cusId: this.cusId,
                startDate: '',
                endDate: '',
            },
            dict: {
                orderPayType: this.$dict.NULL,
            },
        }
    },

    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    minWidth: 60,
                },
                {
                    key: 'payTime',
                    title: '充值时间',
                    align: 'center',
                    minWidth: 180,
                    render: pipeCell('ymdL'),
                },
                {
                    key: 'rechargeAmount',
                    title: '充值金额(元)',
                    align: 'right',
                    minWidth: 120,
                },
                {
                    key: 'poundage',
                    title: '手续费(元)',
                    align: 'right',
                    minWidth: 130,
                },
                {
                    key: 'balance',
                    title: '账户余额(元)',
                    align: 'right',
                    minWidth: 130,
                },
                {
                    key: 'payType',
                    title: '付款方式',
                    align: 'left',
                    minWidth: 130,
                    render: mapCell(this.dict.orderPayType.toList()),
                },
                {
                    key: 'payer',
                    title: '付款人',
                    align: 'left',
                    minWidth: 110,
                },
            ]
        },
    },

    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                this.$dict.get(['order_pay_type']),
                orderRechargeHistory(this.filter),
            ])
                .then((args) => {
                    var [group, view] = args
                    Object.assign(this.dict, group)
                    if (view.data.page) {
                        view.data.page.list.forEach((v) => {
                            v.rechargeAmount = currency(v.rechargeAmount / 100)
                            v.balance = currency(v.balance / 100)
                            v.poundage = currency(v.poundage / 100)
                            v.waterReading = currency(v.waterReading / 100)
                            v.electricReading = currency(
                                v.electricReading / 100
                            )
                        })
                        this.setPageData(view.data)
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },
    },

    created() {
        this.fetch()
    },

    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        var btns = [{ type: 'default', text: '关闭', name: 'cancel' }]
        this.$modal.updateBtns(btns)
    },
}
</script>
<style lang="less">
.top {
    font-size: 20px;
}
.inlineblock {
    display: inline-block;
    margin-left: 20px;
    font-size: 16px;
}
</style>
